import { Routes } from '@angular/router';
import { OriginType } from './origin-type/origin-type';
import { AssociationArea } from './association-area/association-area';
import { ClosureType } from './closure-type/closure-type';
import { DepletionType } from './depletion-type/depletion-type';
import { FuelProvider } from './fuel-provider/fuel-provider';
import { Forecast } from './forecast/forecast';
import { MercosurCommonName } from './mercosur-common-name/mercosur-common-name';
import { Currency } from './currency/currency';
import { ModelType } from './model-type/model-type';
import { PeriodType } from './period-type/period-type';
import { Vendor } from './vendor/vendor';
import { Customer } from './customer/customer';
import { PaymentMode } from './payment-mode/payment-mode';
import { PlanType } from './plan-type/plan-type';
import { QuotaType } from './quota-type/quota-type';
import { InternalOrder } from './internal-order/internal-order';
import { CostCenter } from './cost-center/cost-center';
import { ExchangeRate } from './exchange-rate/exchange-rate';
import { Wbs } from './wbs/wbs';
import { ProfitCenter } from './profit-center/profit-center';
import { Account } from './account/account';
import { CorridorType } from './corridor-type/corridor-type';
import { Period } from './period/period';
import { StopCompensationType } from './stop-compensation-type/stop-compensation-type';
import { StopType } from './stop-type/stop-type';
import { StopRequestor } from './stop-requestor/stop-requestor';
import { SupplierSapBankType } from './supplier-sap-bank-type/supplier-sap-bank-type';
import { VendorContactType } from './vendor-contact-type/vendor-contact-type';
import { PurchaseOrderType } from './purchase-order-type/purchase-order-type';
import { CompanyCode } from './company-code/company-code';
import { PurchaseOrder } from './purchase-order/purchase-order';
import { ContractMasterGroup } from './contract-master-group/contract-master-group';
import { ContractType } from './contract-type/contract-type';
import { SpecialDeal } from './special-deal/special-deal';
import { TariffsModule } from './tariffs-module/tariffs-module';
import { ActivityGroup } from './activity-group/activity-group';
import { CostCategory } from './cost-category/cost-category';
import { VariableGroup } from './variable-group/variable-group';
import { SaleOrderParameter } from './sale-order-parameter/sale-order-parameter';
import { SaleType } from './sale-type/sale-type';
import { GroupingTypeOfVariable } from './grouping-type-of-variable/grouping-type-of-variable';
import { ZoneType } from './zone-type/zone-type';
import { TariffType } from './tariff-type/tariff-type';
import { VariableType } from './variable-type/variable-type';
import { CostReceiverType } from './cost-receiver-type/cost-receiver-type';
import { authGuard, permissionGuard } from '@abp/ng.core';
import { CURRENCY_CONFIG } from './currency/currency.config';
import { ORIGINTYPE_CONFIG } from './origin-type/origin-type.config';
import { CLOSURETYPE_CONFIG } from './closure-type/closure-type.config';
import { DEPLETIONTYPE_CONFIG } from './depletion-type/depletion-type.config';
import { FUELPROVIDER_CONFIG } from './fuel-provider/fuel-provider.config';
import { FORECAST_CONFIG } from './forecast/forecast.config';
import { VARIABLETYPE_CONFIG } from './variable-type/variable-type.config';
import { MERCOSURCOMMONNAME_CONFIG } from './mercosur-common-name/mercosur-common-name.config';
import { MODELTYPE_CONFIG } from './model-type/model-type.config';
import { PERIOD_CONFIG } from './period/period.config';
import { PERIODTYPE_CONFIG } from './period-type/period-type.config';
import { VENDOR_CONFIG } from './vendor/vendor.config';
import { CUSTOMER_CONFIG } from './customer/customer.config';
import { PAYMENTMODE_CONFIG } from './payment-mode/payment-mode.config';
import { PLANTYPE_CONFIG } from './plan-type/plan-type.config';
import { QUOTATYPE_CONFIG } from './quota-type/quota-type.config';
import { INTERNALORDER_CONFIG } from './internal-order/internal-order.config';
import { COSTCENTER_CONFIG } from './cost-center/cost-center.config';
import { EXCHANGERATE_CONFIG } from './exchange-rate/exchange-rate.config';
import { WBS_CONFIG } from './wbs/wbs.config';
import { PROFITCENTER_CONFIG } from './profit-center/profit-center.config';
import { ACCOUNT_CONFIG } from './account/account.config';
import { CORRIDORTYPE_CONFIG } from './corridor-type/corridor-type.config';
import { STOPCOMPENSATIONTYPE_CONFIG } from './stop-compensation-type/stop-compensation-type.config';
import { STOPTYPE_CONFIG } from './stop-type/stop-type.config';
import { STOPREQUESTOR_CONFIG } from './stop-requestor/stop-requestor.config';
import { SUPPLIERSAPBANKTYPE_CONFIG } from './supplier-sap-bank-type/supplier-sap-bank-type.config';
import { VENDORCONTACTTYPE_CONFIG } from './vendor-contact-type/vendor-contact-type.config';
import { PURCHASEORDERTYPE_CONFIG } from './purchase-order-type/purchase-order-type.config';
import { COMPANYCODE_CONFIG } from './company-code/company-code.config';
import { PURCHASEORDER_CONFIG } from './purchase-order/purchase-order.config';
import { CONTRACTMASTERGROUP_CONFIG } from './contract-master-group/contract-master-group.config';
import { CONTRACTTYPE_CONFIG } from './contract-type/contract-type.config';
import { SPECIALDEAL_CONFIG } from './special-deal/special-deal.config';
import { TARIFFSMODULE_CONFIG } from './tariffs-module/tariffs-module.config';
import { ACTIVITYGROUP_CONFIG } from './activity-group/activity-group.config';
import { COSTCATEGORY_CONFIG } from './cost-category/cost-category.config';
import { VARIABLEGROUP_CONFIG } from './variable-group/variable-group.config';
import { SALEORDERPARAMETER_CONFIG } from './sale-order-parameter/sale-order-parameter.config';
import { SALETYPE_CONFIG } from './sale-type/sale-type.config';
import { GROUPINGTYPEOFVARIABLE_CONFIG } from './grouping-type-of-variable/grouping-type-of-variable.config';
import { ZONETYPE_CONFIG } from './zone-type/zone-type.config';
import { TARIFFTYPE_CONFIG } from './tariff-type/tariff-type.config';
import { COST_RECEIVER_TYPE_CONFIG } from './cost-receiver-type/cost-receiver-type.config';
import { VendorContact } from './vendor-contact/vendor-contact';
import { VENDORCONTACT_CONFIG } from './vendor-contact/vendor-contact.config';
import { VendorDetail } from './vendor-detail/vendor-detail';
import { VENDORDETAIL_CONFIG } from './vendor-detail/vendor-detail.config';
import { CUSTOMERDETAIL_CONFIG } from './customer-detail/customer-detail.config';
import { CUSTOMERCOMPANYCODE_CONFIG } from './customer-company-code/customer-company-code.config';
import { PLANT_CONFIG } from './plant/plant.config';
import { STORAGELOCATION_CONFIG } from './storage-location/storage-location.config';
import { VENDORCOMPANYCODE_CONFIG } from './vendor-company-code/vendor-company-code.config';
import { PURCHASEORDERDETAIL_CONFIG } from './purchase-order-detail/purchase-order-detail.config';
import { COSTRECEIVER_CONFIG } from './cost-receiver/cost-receiver.config';
import { WORKFRONT_CONFIG } from './work-front/work-front.config';
import { WORKFRONTTYPE_CONFIG } from './work-front-type/work-front-type.config';
import { VENDORSHIFTWORKINGDAY_CONFIG } from './vendor-shift-working-day/vendor-shift-working-day.config';
import { SUPPLIERBANK_CONFIG } from './supplier-bank/supplier-bank.config';
import { SHIFTWORKINGDAY_CONFIG } from './shift-working-day/shift-working-day.config';
import { SUBSTITUTEDOCUMENTTYPE_CONFIG } from './substitute-document-type/substitute-document-type.config';
import { SHIFT_CONFIG } from './shift/shift.config';
import { SHIFTGROUP_CONFIG } from './shift-group/shift-group.config';
import { PROCESS_CONFIG } from './process/process.config';
import { QUARRYTYPE_CONFIG } from './quarry-type/quarry-type.config';
import { ROADDISTANCE_CONFIG } from './road-distance/road-distance.config';
import { ROADCARGOTYPE_CONFIG } from './road-cargo-type/road-cargo-type.config';
import { DOCUMENTTYPE_CONFIG } from './document-type/document-type.config';
import { ACTIVITY_CONFIG } from './activity/activity.config';
import { STAGE_CONFIG } from './stage/stage.config';
import { ACTIVITYMOMENT_CONFIG } from './activity-moment/activity-moment.config';
import { ACTIVITYPLACE_CONFIG } from './activity-place/activity-place.config';
import { ACTIVITYTOOL_CONFIG } from './activity-tool/activity-tool.config';
import { ACTIVITYREASON_CONFIG } from './activity-reason/activity-reason.config';
import { ACTIVITYPERSTAGE_CONFIG } from './activity-per-stage/activity-per-stage.config';
import { LEVEL_CONFIG } from './level/level.config';
import { LEVELPERACTIVITY_CONFIG } from './level-per-activity/level-per-activity.config';
import { LEVELPERPROCESS_CONFIG } from './level-per-process/level-per-process.config';
import { EVENTCATEGORY_CONFIG } from './event-category/event-category.config';
import { EVENT_CONFIG } from './event/event.config';
import { DOCUMENTTYPEPERACTIVITY_CONFIG } from './document-type-per-activity/document-type-per-activity.config';
import { ACTIVITYPROCESSPARAMETRIZATION_CONFIG } from './activity-process-parametrization/activity-process-parametrization.config';
import { CONSUMABLEACCEPTEDPERACTIVITY_CONFIG } from './consumable-accepted-per-activity/consumable-accepted-per-activity.config';
import { SCOPETYPE_CONFIG } from './scope-type/scope-type.config';
import { ROADACTIVITYPARAMETER_CONFIG } from './road-activity-parameter/road-activity-parameter.config';
import { PROCESSPERPROFILE_CONFIG } from './process-per-profile/process-per-profile.config';
import { PATRIMONYACTIVITYPARAMETER_CONFIG } from './patrimony-activity-parameter/patrimony-activity-parameter.config';
import { SILVICULTUREACTIVITYPARAMETER_CONFIG } from './silviculture-activity-parameter/silviculture-activity-parameter.config';
import { STAGEPERPROCESS_CONFIG } from './stage-per-process/stage-per-process.config';
import { LOCATIONTYPEPERACTIVITY_CONFIG } from './location-type-per-activity/location-type-per-activity.config';
import { HARVESTACTIVITYPARAMETER_CONFIG } from './harvest-activity-parameter/harvest-activity-parameter.config';
import { NURSERYACTIVITYPARAMETER_CONFIG } from './nursery-activity-parameter/nursery-activity-parameter.config';
import { ACTIVITYPERNURSERY_CONFIG } from './activity-per-nursery/activity-per-nursery.config';
import { NURSERYACTIVITYQUALITYCONTROL_CONFIG } from './nursery-activity-quality-control/nursery-activity-quality-control.config';
import { LOGISTICSACTIVITYPARAMETER_CONFIG } from './logistics-activity-parameter/logistics-activity-parameter.config';
import { PERSONPERWORKFRONT_CONFIG } from './person-per-work-front/person-per-work-front.config';
import { MACHINEPERWORKFRONT_CONFIG } from './machine-per-work-front/machine-per-work-front.config';
import { CustomerDetail } from './customer-detail/customer-detail';
import { CustomerCompanyCode } from './customer-company-code/customer-company-code';
import { Plant } from './plant/plant';
import { StorageLocation } from './storage-location/storage-location';
import { VendorCompanyCode } from './vendor-company-code/vendor-company-code';
import { PurchaseOrderDetail } from './purchase-order-detail/purchase-order-detail';
import { CostReceiver } from './cost-receiver/cost-receiver';
import { WorkFront } from './work-front/work-front';
import { WorkFrontType } from './work-front-type/work-front-type';
import { VendorShiftWorkingDay } from './vendor-shift-working-day/vendor-shift-working-day';
import { SupplierBank } from './supplier-bank/supplier-bank';
import { ShiftWorkingDay } from './shift-working-day/shift-working-day';
import { SubstituteDocumentType } from './substitute-document-type/substitute-document-type';
import { Shift } from './shift/shift';
import { ShiftGroup } from './shift-group/shift-group';
import { Process } from './process/process';
import { QuarryType } from './quarry-type/quarry-type';
import { RoadDistance } from './road-distance/road-distance';
import { RoadCargoType } from './road-cargo-type/road-cargo-type';
import { DocumentType } from './document-type/document-type';
import { Activity } from './activity/activity';
import { Stage } from './stage/stage';
import { ActivityMoment } from './activity-moment/activity-moment';
import { ActivityPlace } from './activity-place/activity-place';
import { ActivityTool } from './activity-tool/activity-tool';
import { ActivityReason } from './activity-reason/activity-reason';
import { ActivityPerStage } from './activity-per-stage/activity-per-stage';
import { Level } from './level/level';
import { LevelPerActivity } from './level-per-activity/level-per-activity';
import { LevelPerProcess } from './level-per-process/level-per-process';
import { EventCategory } from './event-category/event-category';
import { Event } from './event/event';
import { DocumentTypePerActivity } from './document-type-per-activity/document-type-per-activity';
import { ActivityProcessParametrization } from './activity-process-parametrization/activity-process-parametrization';
import { ConsumableAcceptedPerActivity } from './consumable-accepted-per-activity/consumable-accepted-per-activity';
import { ScopeType } from './scope-type/scope-type';
import { RoadActivityParameter } from './road-activity-parameter/road-activity-parameter';
import { ProcessPerProfile } from './process-per-profile/process-per-profile';
import { PatrimonyActivityParameter } from './patrimony-activity-parameter/patrimony-activity-parameter';
import { SilvicultureActivityParameter } from './silviculture-activity-parameter/silviculture-activity-parameter';
import { StagePerProcess } from './stage-per-process/stage-per-process';
import { LocationTypePerActivity } from './location-type-per-activity/location-type-per-activity';
import { HarvestActivityParameter } from './harvest-activity-parameter/harvest-activity-parameter';
import { NurseryActivityParameter } from './nursery-activity-parameter/nursery-activity-parameter';
import { ActivityPerNursery } from './activity-per-nursery/activity-per-nursery';
import { NurseryActivityQualityControl } from './nursery-activity-quality-control/nursery-activity-quality-control';
import { LogisticsActivityParameter } from './logistics-activity-parameter/logistics-activity-parameter';
import { PersonPerWorkFront } from './person-per-work-front/person-per-work-front';
import { MachinePerWorkFront } from './machine-per-work-front/machine-per-work-front';
import { ASSOCIATIONAREA_CONFIG } from './association-area/association-area.config';
import { ROUTECORRIDOR_CONFIG } from './route-corridor/route-corridor.config';
import { CLOSINGSTAGESTATUSPARAMETERS_CONFIG } from './closing-stage-status-parameters/closing-stage-status-parameters.config';
import { CONTRACTTYPEUSAGE_CONFIG } from './contract-type-usage/contract-type-usage.config';
import { CONTRACTVARIABLE_CONFIG } from './contract-variable/contract-variable.config';
import { FUELCONSUMPTIONTYPE_CONFIG } from './fuel-consumption-type/fuel-consumption-type.config';
import { CONTRACTTYPEASSET_CONFIG } from './contract-type-asset/contract-type-asset.config';
import { CONDITIONALFORCALCULATION_CONFIG } from './conditional-for-calculation/conditional-for-calculation.config';
import { CONTRACTTYPEGROUP_CONFIG } from './contract-type-group/contract-type-group.config';
import { SINGLECUSTOMSDECLARATION_CONFIG } from './single-customs-declaration/single-customs-declaration.config';
import { SALEORDERPARAMETRIZATION_CONFIG } from './sale-order-parametrization/sale-order-parametrization.config';
import { PROPERTYTYPEREGIONPARAMETER_CONFIG } from './property-type-region-parameter/property-type-region-parameter.config';
import { EXCHANGETYPE_CONFIG } from './exchange-type/exchange-type.config';
import { DEPLETIONEXCHANGEAMOUNT_CONFIG } from './depletion-exchange-amount/depletion-exchange-amount.config';
import { VENDORCONTRACTTYPE_CONFIG } from './vendor-contract-type/vendor-contract-type.config';
import { RouteCorridor } from './route-corridor/route-corridor';
import { ClosingStageStatusParameters } from './closing-stage-status-parameters/closing-stage-status-parameters';
import { ContractTypeUsage } from './contract-type-usage/contract-type-usage';
import { ContractVariable } from './contract-variable/contract-variable';
import { FuelConsumptionType } from './fuel-consumption-type/fuel-consumption-type';
import { ContractTypeAsset } from './contract-type-asset/contract-type-asset';
import { ConditionalForCalculation } from './conditional-for-calculation/conditional-for-calculation';
import { ContractTypeGroup } from './contract-type-group/contract-type-group';
import { SingleCustomsDeclaration } from './single-customs-declaration/single-customs-declaration';
import { SaleOrderParametrization } from './sale-order-parametrization/sale-order-parametrization';
import { PropertyTypeRegionParameter } from './property-type-region-parameter/property-type-region-parameter';
import { ExchangeType } from './exchange-type/exchange-type';
import { DepletionExchangeAmount } from './depletion-exchange-amount/depletion-exchange-amount';
import { VendorContractType } from './vendor-contract-type/vendor-contract-type';
import { PaymentType } from './payment-type/payment-type';
import { PAYMENTTYPE_CONFIG } from './payment-type/payment-type.config';
import { FomentIndexValue } from './foment-index-value/foment-index-value';
import { FOMENTINDEXVALUE_CONFIG } from './foment-index-value/foment-index-value.config';
import { FomentIndex } from './foment-index/foment-index';
import { FOMENTINDEX_CONFIG } from './foment-index/foment-index.config';
import { FomentAreaStatus } from './foment-area-status/foment-area-status';
import { FOMENTAREASTATUS_CONFIG } from './foment-area-status/foment-area-status.config';
import { ContractAreaStatus } from './contract-area-status/contract-area-status';
import { CONTRACTAREASTATUS_CONFIG } from './contract-area-status/contract-area-status.config';
import { SALEORDERPARAMETERVALUE_CONFIG } from './sale-order-parameter-value/sale-order-parameter-value.config';
import { VENDORTYPE_CONFIG } from './vendor-type/vendor-type.config';
import { ASSET_CONFIG } from './asset/asset.config';
import { INTERNALORDERTYPE_CONFIG } from './internal-order-type/internal-order-type.config';
import { MOVEMENTTYPE_CONFIG } from './movement-type/movement-type.config';
import { SERVICEMASTER_CONFIG } from './service-master/service-master.config';
import { SAPMATERIALTYPE_CONFIG } from './sap-material-type/sap-material-type.config';
import { SAPMATERIALGROUP_CONFIG } from './sap-material-group/sap-material-group.config';
import { SAPMATERIAL_CONFIG } from './sap-material/sap-material.config';
import { SaleOrderParameterValue } from './sale-order-parameter-value/sale-order-parameter-value';
import { VendorType } from './vendor-type/vendor-type';
import { Asset } from './asset/asset';
import { InternalOrderType } from './internal-order-type/internal-order-type';
import { MovementType } from './movement-type/movement-type';
import { ServiceMaster } from './service-master/service-master';
import { SapMaterialType } from './sap-material-type/sap-material-type';
import { SapMaterialGroup } from './sap-material-group/sap-material-group';
import { SapMaterial } from './sap-material/sap-material';

import { ContractTypeActivity } from './contract-type-activity/contract-type-activity';
import { CONTRACTTYPEACTIVITY_CONFIG } from './contract-type-activity/contract-type-activity.config';
import { ContractTypeForecast } from './contract-type-forecast/contract-type-forecast';
import { CONTRACTTYPEFORECAST_CONFIG } from './contract-type-forecast/contract-type-forecast.config';
import { ContractTypeMgsParameter } from './contract-type-mgs-parameter/contract-type-mgs-parameter';
import { CONTRACTTYPEMGSPARAMETER_CONFIG } from './contract-type-mgs-parameter/contract-type-mgs-parameter.config';
import { ContractTypePerPropertyType } from './contract-type-per-property-type/contract-type-per-property-type';
import { CONTRACTTYPEPERPROPERTYTYPE_CONFIG } from './contract-type-per-property-type/contract-type-per-property-type.config';
import { ContractTypeSapParameter } from './contract-type-sap-parameter/contract-type-sap-parameter';
import { CONTRACTTYPESAPPARAMETER_CONFIG } from './contract-type-sap-parameter/contract-type-sap-parameter.config';
import { ContractTypeTax } from './contract-type-tax/contract-type-tax';
import { CONTRACTTYPETAX_CONFIG } from './contract-type-tax/contract-type-tax.config';
import { SapFicoParameter } from './sap-fico-parameter/sap-fico-parameter';
import { SAPFICOPARAMETER_CONFIG } from './sap-fico-parameter/sap-fico-parameter.config';
import { SapFiParameter } from './sap-fi-parameter/sap-fi-parameter';
import { SAPFIPARAMETER_CONFIG } from './sap-fi-parameter/sap-fi-parameter.config';
import { SapServiceEntrySheetParameter } from './sap-service-entry-sheet-parameter/sap-service-entry-sheet-parameter';
import { SAPSERVICEENTRYSHEETPARAMETER_CONFIG } from './sap-service-entry-sheet-parameter/sap-service-entry-sheet-parameter.config';
import { SingleCustomsDeclarationMaterial } from './single-customs-declaration-material/single-customs-declaration-material';
import { SINGLECUSTOMSDECLARATIONMATERIAL_CONFIG } from './single-customs-declaration-material/single-customs-declaration-material.config';
import { VehicleTypeTons } from './vehicle-type-tons/vehicle-type-tons';
import { VEHICLETYPETONS_CONFIG } from './vehicle-type-tons/vehicle-type-tons.config';
import { LogisticsMainTruckCount } from './logistics-main-truck-count/logistics-main-truck-count';
import { LOGISTICSMAINTRUCKCOUNT_CONFIG } from './logistics-main-truck-count/logistics-main-truck-count.config';
import { LogisticsTruckCount } from './logistics-truck-count/logistics-truck-count';
import { LOGISTICSTRUCKCOUNT_CONFIG } from './logistics-truck-count/logistics-truck-count.config';
import { SapAccountCompanyCode } from './sap-account-company-code/sap-account-company-code';
import { SAPACCOUNTCOMPANYCODE_CONFIG } from './sap-account-company-code/sap-account-company-code.config';
import { SapRelationSapAccountOldAccount } from './sap-relation-sap-account-old-account/sap-relation-sap-account-old-account';
import { SAPRELATIONSAPACCOUNTOLDACCOUNT_CONFIG } from './sap-relation-sap-account-old-account/sap-relation-sap-account-old-account.config';
import { SapOldProfitCenter } from './sap-old-profit-center/sap-old-profit-center';
import { SAPOLDPROFITCENTER_CONFIG } from './sap-old-profit-center/sap-old-profit-center.config';
import { AccountDetail } from './account-detail/account-detail';
import { ACCOUNTDETAIL_CONFIG } from './account-detail/account-detail.config';
import { SapAccountGroup } from './sap-account-group/sap-account-group';
import { SAPACCOUNTGROUP_CONFIG } from './sap-account-group/sap-account-group.config';
import { SapAccountSubgroup } from './sap-account-subgroup/sap-account-subgroup';
import { SAPACCOUNTSUBGROUP_CONFIG } from './sap-account-subgroup/sap-account-subgroup.config';
import { SapAmountType } from './sap-amount-type/sap-amount-type';
import { SAPAMOUNTTYPE_CONFIG } from './sap-amount-type/sap-amount-type.config';
import { SapDocumentType } from './sap-document-type/sap-document-type';
import { SAPDOCUMENTTYPE_CONFIG } from './sap-document-type/sap-document-type.config';
import { OldAccount } from './old-account/old-account';
import { OLDACCOUNT_CONFIG } from './old-account/old-account.config';
import { SapPostingKey } from './sap-posting-key/sap-posting-key';
import { SAPPOSTINGKEY_CONFIG } from './sap-posting-key/sap-posting-key.config';
import { Tax } from './tax/tax';
import { TAX_CONFIG } from './tax/tax.config';
import { PROPERTYNURSERYVENDOR_CONFIG } from './property-nursery-vendor/property-nursery-vendor.config';
import { SALEMETHOD_CONFIG } from './sale-method/sale-method.config';
import { VIASAPTRANSPORT_CONFIG } from './via-sap-transport/via-sap-transport.config';
import { SALECLAUSE_CONFIG } from './sale-clause/sale-clause.config';
import { TRANSFERTYPE_CONFIG } from './transfer-type/transfer-type.config';
import { VIASICFETRANSPORT_CONFIG } from './via-sicfe-transport/via-sicfe-transport.config';
import { VENDORCONSTRAINTSPERREGION_CONFIG } from './vendor-constraints-per-region/vendor-constraints-per-region.config';
import { PropertyNurseryVendor } from './property-nursery-vendor/property-nursery-vendor';
import { SaleMethod } from './sale-method/sale-method';
import { ViaSapTransport } from './via-sap-transport/via-sap-transport';
import { SaleClause } from './sale-clause/sale-clause';
import { TransferType } from './transfer-type/transfer-type';
import { ViaSicfeTransport } from './via-sicfe-transport/via-sicfe-transport';
import { VendorConstraintsPerRegion } from './vendor-constraints-per-region/vendor-constraints-per-region';
export const CONTROLLING_ROUTES: Routes = [
  {
    path: 'payment-type',
    pathMatch: 'full',
    component: PaymentType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PAYMENTTYPE_CONFIG.permission,
      showInMenu: PAYMENTTYPE_CONFIG.showInMenu,
      menuCategory: PAYMENTTYPE_CONFIG.menuCategory,
      menuSubcategory: PAYMENTTYPE_CONFIG.menuSubcategory,
      menuTitle: PAYMENTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'foment-index-value',
    pathMatch: 'full',
    component: FomentIndexValue,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FOMENTINDEXVALUE_CONFIG.permission,
      showInMenu: FOMENTINDEXVALUE_CONFIG.showInMenu,
      menuCategory: FOMENTINDEXVALUE_CONFIG.menuCategory,
      menuSubcategory: FOMENTINDEXVALUE_CONFIG.menuSubcategory,
      menuTitle: FOMENTINDEXVALUE_CONFIG.localizationKey,
    },
  },
  {
    path: 'foment-index',
    pathMatch: 'full',
    component: FomentIndex,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FOMENTINDEX_CONFIG.permission,
      showInMenu: FOMENTINDEX_CONFIG.showInMenu,
      menuCategory: FOMENTINDEX_CONFIG.menuCategory,
      menuSubcategory: FOMENTINDEX_CONFIG.menuSubcategory,
      menuTitle: FOMENTINDEX_CONFIG.localizationKey,
    },
  },
  {
    path: 'foment-area-status',
    pathMatch: 'full',
    component: FomentAreaStatus,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FOMENTAREASTATUS_CONFIG.permission,
      showInMenu: FOMENTAREASTATUS_CONFIG.showInMenu,
      menuCategory: FOMENTAREASTATUS_CONFIG.menuCategory,
      menuSubcategory: FOMENTAREASTATUS_CONFIG.menuSubcategory,
      menuTitle: FOMENTAREASTATUS_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-area-status',
    pathMatch: 'full',
    component: ContractAreaStatus,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTAREASTATUS_CONFIG.permission,
      showInMenu: CONTRACTAREASTATUS_CONFIG.showInMenu,
      menuCategory: CONTRACTAREASTATUS_CONFIG.menuCategory,
      menuSubcategory: CONTRACTAREASTATUS_CONFIG.menuSubcategory,
      menuTitle: CONTRACTAREASTATUS_CONFIG.localizationKey,
    },
  },
  {
    path: 'origin-type',
    pathMatch: 'full',
    component: OriginType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ORIGINTYPE_CONFIG.permission,
      showInMenu: ORIGINTYPE_CONFIG.showInMenu,
      menuCategory: ORIGINTYPE_CONFIG.menuCategory,
      menuSubcategory: ORIGINTYPE_CONFIG.menuSubcategory,
      menuTitle: ORIGINTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'association-area',
    pathMatch: 'full',
    component: AssociationArea,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ASSOCIATIONAREA_CONFIG.permission,
      showInMenu: ASSOCIATIONAREA_CONFIG.showInMenu,
      menuCategory: ASSOCIATIONAREA_CONFIG.menuCategory,
      menuSubcategory: ASSOCIATIONAREA_CONFIG.menuSubcategory,
      menuTitle: ASSOCIATIONAREA_CONFIG.localizationKey,
    },
  },
  {
    path: 'closure-type',
    pathMatch: 'full',
    component: ClosureType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CLOSURETYPE_CONFIG.permission,
      showInMenu: CLOSURETYPE_CONFIG.showInMenu,
      menuCategory: CLOSURETYPE_CONFIG.menuCategory,
      menuSubcategory: CLOSURETYPE_CONFIG.menuSubcategory,
      menuTitle: CLOSURETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'depletion-type',
    pathMatch: 'full',
    component: DepletionType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DEPLETIONTYPE_CONFIG.permission,
      showInMenu: DEPLETIONTYPE_CONFIG.showInMenu,
      menuCategory: DEPLETIONTYPE_CONFIG.menuCategory,
      menuSubcategory: DEPLETIONTYPE_CONFIG.menuSubcategory,
      menuTitle: DEPLETIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'fuel-provider',
    pathMatch: 'full',
    component: FuelProvider,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FUELPROVIDER_CONFIG.permission,
      showInMenu: FUELPROVIDER_CONFIG.showInMenu,
      menuCategory: FUELPROVIDER_CONFIG.menuCategory,
      menuSubcategory: FUELPROVIDER_CONFIG.menuSubcategory,
      menuTitle: FUELPROVIDER_CONFIG.localizationKey,
    },
  },
  {
    path: 'forecast',
    pathMatch: 'full',
    component: Forecast,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FORECAST_CONFIG.permission,
      showInMenu: FORECAST_CONFIG.showInMenu,
      menuCategory: FORECAST_CONFIG.menuCategory,
      menuSubcategory: FORECAST_CONFIG.menuSubcategory,
      menuTitle: FORECAST_CONFIG.localizationKey,
    },
  },
  {
    path: 'currency',
    pathMatch: 'full',
    component: Currency,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CURRENCY_CONFIG.permission,
      showInMenu: CURRENCY_CONFIG.showInMenu,
      menuCategory: CURRENCY_CONFIG.menuCategory,
      menuSubcategory: CURRENCY_CONFIG.menuSubcategory,
      menuTitle: CURRENCY_CONFIG.localizationKey,
    },
  },
  {
    path: 'mercosur-common-name',
    pathMatch: 'full',
    component: MercosurCommonName,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MERCOSURCOMMONNAME_CONFIG.permission,
      showInMenu: MERCOSURCOMMONNAME_CONFIG.showInMenu,
      menuCategory: MERCOSURCOMMONNAME_CONFIG.menuCategory,
      menuSubcategory: MERCOSURCOMMONNAME_CONFIG.menuSubcategory,
      menuTitle: MERCOSURCOMMONNAME_CONFIG.localizationKey,
    },
  },
  {
    path: 'model-type',
    pathMatch: 'full',
    component: ModelType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MODELTYPE_CONFIG.permission,
      showInMenu: MODELTYPE_CONFIG.showInMenu,
      menuCategory: MODELTYPE_CONFIG.menuCategory,
      menuSubcategory: MODELTYPE_CONFIG.menuSubcategory,
      menuTitle: MODELTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'period-type',
    pathMatch: 'full',
    component: PeriodType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PERIODTYPE_CONFIG.permission,
      showInMenu: PERIODTYPE_CONFIG.showInMenu,
      menuCategory: PERIODTYPE_CONFIG.menuCategory,
      menuSubcategory: PERIODTYPE_CONFIG.menuSubcategory,
      menuTitle: PERIODTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor',
    pathMatch: 'full',
    component: Vendor,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDOR_CONFIG.permission,
      showInMenu: VENDOR_CONFIG.showInMenu,
      menuCategory: VENDOR_CONFIG.menuCategory,
      menuSubcategory: VENDOR_CONFIG.menuSubcategory,
      menuTitle: VENDOR_CONFIG.localizationKey,
    },
  },
  {
    path: 'customer',
    pathMatch: 'full',
    component: Customer,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CUSTOMER_CONFIG.permission,
      showInMenu: CUSTOMER_CONFIG.showInMenu,
      menuCategory: CUSTOMER_CONFIG.menuCategory,
      menuSubcategory: CUSTOMER_CONFIG.menuSubcategory,
      menuTitle: CUSTOMER_CONFIG.localizationKey,
    },
  },
  {
    path: 'payment-mode',
    pathMatch: 'full',
    component: PaymentMode,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PAYMENTMODE_CONFIG.permission,
      showInMenu: PAYMENTMODE_CONFIG.showInMenu,
      menuCategory: PAYMENTMODE_CONFIG.menuCategory,
      menuSubcategory: PAYMENTMODE_CONFIG.menuSubcategory,
      menuTitle: PAYMENTMODE_CONFIG.localizationKey,
    },
  },
  {
    path: 'plan-type',
    pathMatch: 'full',
    component: PlanType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PLANTYPE_CONFIG.permission,
      showInMenu: PLANTYPE_CONFIG.showInMenu,
      menuCategory: PLANTYPE_CONFIG.menuCategory,
      menuSubcategory: PLANTYPE_CONFIG.menuSubcategory,
      menuTitle: PLANTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'quota-type',
    pathMatch: 'full',
    component: QuotaType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: QUOTATYPE_CONFIG.permission,
      showInMenu: QUOTATYPE_CONFIG.showInMenu,
      menuCategory: QUOTATYPE_CONFIG.menuCategory,
      menuSubcategory: QUOTATYPE_CONFIG.menuSubcategory,
      menuTitle: QUOTATYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'internal-order',
    pathMatch: 'full',
    component: InternalOrder,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INTERNALORDER_CONFIG.permission,
      showInMenu: INTERNALORDER_CONFIG.showInMenu,
      menuCategory: INTERNALORDER_CONFIG.menuCategory,
      menuSubcategory: INTERNALORDER_CONFIG.menuSubcategory,
      menuTitle: INTERNALORDER_CONFIG.localizationKey,
    },
  },
  {
    path: 'cost-center',
    pathMatch: 'full',
    component: CostCenter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: COSTCENTER_CONFIG.permission,
      showInMenu: COSTCENTER_CONFIG.showInMenu,
      menuCategory: COSTCENTER_CONFIG.menuCategory,
      menuSubcategory: COSTCENTER_CONFIG.menuSubcategory,
      menuTitle: COSTCENTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'exchange-rate',
    pathMatch: 'full',
    component: ExchangeRate,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: EXCHANGERATE_CONFIG.permission,
      showInMenu: EXCHANGERATE_CONFIG.showInMenu,
      menuCategory: EXCHANGERATE_CONFIG.menuCategory,
      menuSubcategory: EXCHANGERATE_CONFIG.menuSubcategory,
      menuTitle: EXCHANGERATE_CONFIG.localizationKey,
    },
  },
  {
    path: 'wbs',
    pathMatch: 'full',
    component: Wbs,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WBS_CONFIG.permission,
      showInMenu: WBS_CONFIG.showInMenu,
      menuCategory: WBS_CONFIG.menuCategory,
      menuSubcategory: WBS_CONFIG.menuSubcategory,
      menuTitle: WBS_CONFIG.localizationKey,
    },
  },
  {
    path: 'profit-center',
    pathMatch: 'full',
    component: ProfitCenter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROFITCENTER_CONFIG.permission,
      showInMenu: PROFITCENTER_CONFIG.showInMenu,
      menuCategory: PROFITCENTER_CONFIG.menuCategory,
      menuSubcategory: PROFITCENTER_CONFIG.menuSubcategory,
      menuTitle: PROFITCENTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'account',
    pathMatch: 'full',
    component: Account,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACCOUNT_CONFIG.permission,
      showInMenu: ACCOUNT_CONFIG.showInMenu,
      menuCategory: ACCOUNT_CONFIG.menuCategory,
      menuSubcategory: ACCOUNT_CONFIG.menuSubcategory,
      menuTitle: ACCOUNT_CONFIG.localizationKey,
    },
  },
  {
    path: 'corridor-type',
    pathMatch: 'full',
    component: CorridorType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CORRIDORTYPE_CONFIG.permission,
      showInMenu: CORRIDORTYPE_CONFIG.showInMenu,
      menuCategory: CORRIDORTYPE_CONFIG.menuCategory,
      menuSubcategory: CORRIDORTYPE_CONFIG.menuSubcategory,
      menuTitle: CORRIDORTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'period',
    pathMatch: 'full',
    component: Period,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PERIOD_CONFIG.permission,
      showInMenu: PERIOD_CONFIG.showInMenu,
      menuCategory: PERIOD_CONFIG.menuCategory,
      menuSubcategory: PERIOD_CONFIG.menuSubcategory,
      menuTitle: PERIOD_CONFIG.localizationKey,
    },
  },
  {
    path: 'stop-compensation-type',
    pathMatch: 'full',
    component: StopCompensationType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STOPCOMPENSATIONTYPE_CONFIG.permission,
      showInMenu: STOPCOMPENSATIONTYPE_CONFIG.showInMenu,
      menuCategory: STOPCOMPENSATIONTYPE_CONFIG.menuCategory,
      menuSubcategory: STOPCOMPENSATIONTYPE_CONFIG.menuSubcategory,
      menuTitle: STOPCOMPENSATIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'stop-type',
    pathMatch: 'full',
    component: StopType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STOPTYPE_CONFIG.permission,
      showInMenu: STOPTYPE_CONFIG.showInMenu,
      menuCategory: STOPTYPE_CONFIG.menuCategory,
      menuSubcategory: STOPTYPE_CONFIG.menuSubcategory,
      menuTitle: STOPTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'stop-requestor',
    pathMatch: 'full',
    component: StopRequestor,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STOPREQUESTOR_CONFIG.permission,
      showInMenu: STOPREQUESTOR_CONFIG.showInMenu,
      menuCategory: STOPREQUESTOR_CONFIG.menuCategory,
      menuSubcategory: STOPREQUESTOR_CONFIG.menuSubcategory,
      menuTitle: STOPREQUESTOR_CONFIG.localizationKey,
    },
  },
  {
    path: 'supplier-sap-bank-type',
    pathMatch: 'full',
    component: SupplierSapBankType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SUPPLIERSAPBANKTYPE_CONFIG.permission,
      showInMenu: SUPPLIERSAPBANKTYPE_CONFIG.showInMenu,
      menuCategory: SUPPLIERSAPBANKTYPE_CONFIG.menuCategory,
      menuSubcategory: SUPPLIERSAPBANKTYPE_CONFIG.menuSubcategory,
      menuTitle: SUPPLIERSAPBANKTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor-contact-type',
    pathMatch: 'full',
    component: VendorContactType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDORCONTACTTYPE_CONFIG.permission,
      showInMenu: VENDORCONTACTTYPE_CONFIG.showInMenu,
      menuCategory: VENDORCONTACTTYPE_CONFIG.menuCategory,
      menuSubcategory: VENDORCONTACTTYPE_CONFIG.menuSubcategory,
      menuTitle: VENDORCONTACTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'purchase-order-type',
    pathMatch: 'full',
    component: PurchaseOrderType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PURCHASEORDERTYPE_CONFIG.permission,
      showInMenu: PURCHASEORDERTYPE_CONFIG.showInMenu,
      menuCategory: PURCHASEORDERTYPE_CONFIG.menuCategory,
      menuSubcategory: PURCHASEORDERTYPE_CONFIG.menuSubcategory,
      menuTitle: PURCHASEORDERTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'company-code',
    pathMatch: 'full',
    component: CompanyCode,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: COMPANYCODE_CONFIG.permission,
      showInMenu: COMPANYCODE_CONFIG.showInMenu,
      menuCategory: COMPANYCODE_CONFIG.menuCategory,
      menuSubcategory: COMPANYCODE_CONFIG.menuSubcategory,
      menuTitle: COMPANYCODE_CONFIG.localizationKey,
    },
  },
  {
    path: 'purchase-order',
    pathMatch: 'full',
    component: PurchaseOrder,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PURCHASEORDER_CONFIG.permission,
      showInMenu: PURCHASEORDER_CONFIG.showInMenu,
      menuCategory: PURCHASEORDER_CONFIG.menuCategory,
      menuSubcategory: PURCHASEORDER_CONFIG.menuSubcategory,
      menuTitle: PURCHASEORDER_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-master-group',
    pathMatch: 'full',
    component: ContractMasterGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTMASTERGROUP_CONFIG.permission,
      showInMenu: CONTRACTMASTERGROUP_CONFIG.showInMenu,
      menuCategory: CONTRACTMASTERGROUP_CONFIG.menuCategory,
      menuSubcategory: CONTRACTMASTERGROUP_CONFIG.menuSubcategory,
      menuTitle: CONTRACTMASTERGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-type',
    pathMatch: 'full',
    component: ContractType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPE_CONFIG.permission,
      showInMenu: CONTRACTTYPE_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPE_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPE_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'special-deal',
    pathMatch: 'full',
    component: SpecialDeal,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SPECIALDEAL_CONFIG.permission,
      showInMenu: SPECIALDEAL_CONFIG.showInMenu,
      menuCategory: SPECIALDEAL_CONFIG.menuCategory,
      menuSubcategory: SPECIALDEAL_CONFIG.menuSubcategory,
      menuTitle: SPECIALDEAL_CONFIG.localizationKey,
    },
  },
  {
    path: 'tariffs-module',
    pathMatch: 'full',
    component: TariffsModule,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TARIFFSMODULE_CONFIG.permission,
      showInMenu: TARIFFSMODULE_CONFIG.showInMenu,
      menuCategory: TARIFFSMODULE_CONFIG.menuCategory,
      menuSubcategory: TARIFFSMODULE_CONFIG.menuSubcategory,
      menuTitle: TARIFFSMODULE_CONFIG.localizationKey,
    },
  },
  {
    path: 'activity-group',
    pathMatch: 'full',
    component: ActivityGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACTIVITYGROUP_CONFIG.permission,
      showInMenu: ACTIVITYGROUP_CONFIG.showInMenu,
      menuCategory: ACTIVITYGROUP_CONFIG.menuCategory,
      menuSubcategory: ACTIVITYGROUP_CONFIG.menuSubcategory,
      menuTitle: ACTIVITYGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'cost-category',
    pathMatch: 'full',
    component: CostCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: COSTCATEGORY_CONFIG.permission,
      showInMenu: COSTCATEGORY_CONFIG.showInMenu,
      menuCategory: COSTCATEGORY_CONFIG.menuCategory,
      menuSubcategory: COSTCATEGORY_CONFIG.menuSubcategory,
      menuTitle: COSTCATEGORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'variable-group',
    pathMatch: 'full',
    component: VariableGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VARIABLEGROUP_CONFIG.permission,
      showInMenu: VARIABLEGROUP_CONFIG.showInMenu,
      menuCategory: VARIABLEGROUP_CONFIG.menuCategory,
      menuSubcategory: VARIABLEGROUP_CONFIG.menuSubcategory,
      menuTitle: VARIABLEGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'sale-order-parameter',
    pathMatch: 'full',
    component: SaleOrderParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SALEORDERPARAMETER_CONFIG.permission,
      showInMenu: SALEORDERPARAMETER_CONFIG.showInMenu,
      menuCategory: SALEORDERPARAMETER_CONFIG.menuCategory,
      menuSubcategory: SALEORDERPARAMETER_CONFIG.menuSubcategory,
      menuTitle: SALEORDERPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'sale-type',
    pathMatch: 'full',
    component: SaleType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SALETYPE_CONFIG.permission,
      showInMenu: SALETYPE_CONFIG.showInMenu,
      menuCategory: SALETYPE_CONFIG.menuCategory,
      menuSubcategory: SALETYPE_CONFIG.menuSubcategory,
      menuTitle: SALETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'grouping-type-of-variable',
    pathMatch: 'full',
    component: GroupingTypeOfVariable,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GROUPINGTYPEOFVARIABLE_CONFIG.permission,
      showInMenu: GROUPINGTYPEOFVARIABLE_CONFIG.showInMenu,
      menuCategory: GROUPINGTYPEOFVARIABLE_CONFIG.menuCategory,
      menuSubcategory: GROUPINGTYPEOFVARIABLE_CONFIG.menuSubcategory,
      menuTitle: GROUPINGTYPEOFVARIABLE_CONFIG.localizationKey,
    },
  },
  {
    path: 'zone-type',
    pathMatch: 'full',
    component: ZoneType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ZONETYPE_CONFIG.permission,
      showInMenu: ZONETYPE_CONFIG.showInMenu,
      menuCategory: ZONETYPE_CONFIG.menuCategory,
      menuSubcategory: ZONETYPE_CONFIG.menuSubcategory,
      menuTitle: ZONETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'tariff-type',
    pathMatch: 'full',
    component: TariffType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TARIFFTYPE_CONFIG.permission,
      showInMenu: TARIFFTYPE_CONFIG.showInMenu,
      menuCategory: TARIFFTYPE_CONFIG.menuCategory,
      menuSubcategory: TARIFFTYPE_CONFIG.menuSubcategory,
      menuTitle: TARIFFTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'variable-type',
    pathMatch: 'full',
    component: VariableType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VARIABLETYPE_CONFIG.permission,
      showInMenu: VARIABLETYPE_CONFIG.showInMenu,
      menuCategory: VARIABLETYPE_CONFIG.menuCategory,
      menuSubcategory: VARIABLETYPE_CONFIG.menuSubcategory,
      menuTitle: VARIABLETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'cost-receiver-type',
    pathMatch: 'full',
    component: CostReceiverType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: COST_RECEIVER_TYPE_CONFIG.permission,
      showInMenu: COST_RECEIVER_TYPE_CONFIG.showInMenu,
      menuCategory: COST_RECEIVER_TYPE_CONFIG.menuCategory,
      menuSubcategory: COST_RECEIVER_TYPE_CONFIG.menuSubcategory,
      menuTitle: COST_RECEIVER_TYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor-contact',
    pathMatch: 'full',
    component: VendorContact,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDORCONTACT_CONFIG.permission,
      showInMenu: VENDORCONTACT_CONFIG.showInMenu,
      menuCategory: VENDORCONTACT_CONFIG.menuCategory,
      menuSubcategory: VENDORCONTACT_CONFIG.menuSubcategory,
      menuTitle: VENDORCONTACT_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor-detail',
    pathMatch: 'full',
    component: VendorDetail,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDORDETAIL_CONFIG.permission,
      showInMenu: VENDORDETAIL_CONFIG.showInMenu,
      menuCategory: VENDORDETAIL_CONFIG.menuCategory,
      menuSubcategory: VENDORDETAIL_CONFIG.menuSubcategory,
      menuTitle: VENDORDETAIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'customer-detail',
    pathMatch: 'full',
    component: CustomerDetail,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CUSTOMERDETAIL_CONFIG.permission,
      showInMenu: CUSTOMERDETAIL_CONFIG.showInMenu,
      menuCategory: CUSTOMERDETAIL_CONFIG.menuCategory,
      menuSubcategory: CUSTOMERDETAIL_CONFIG.menuSubcategory,
      menuTitle: CUSTOMERDETAIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'customer-company-code',
    pathMatch: 'full',
    component: CustomerCompanyCode,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CUSTOMERCOMPANYCODE_CONFIG.permission,
      showInMenu: CUSTOMERCOMPANYCODE_CONFIG.showInMenu,
      menuCategory: CUSTOMERCOMPANYCODE_CONFIG.menuCategory,
      menuSubcategory: CUSTOMERCOMPANYCODE_CONFIG.menuSubcategory,
      menuTitle: CUSTOMERCOMPANYCODE_CONFIG.localizationKey,
    },
  },
  {
    path: 'plant',
    pathMatch: 'full',
    component: Plant,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PLANT_CONFIG.permission,
      showInMenu: PLANT_CONFIG.showInMenu,
      menuCategory: PLANT_CONFIG.menuCategory,
      menuSubcategory: PLANT_CONFIG.menuSubcategory,
      menuTitle: PLANT_CONFIG.localizationKey,
    },
  },
  {
    path: 'storage-location',
    pathMatch: 'full',
    component: StorageLocation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STORAGELOCATION_CONFIG.permission,
      showInMenu: STORAGELOCATION_CONFIG.showInMenu,
      menuCategory: STORAGELOCATION_CONFIG.menuCategory,
      menuSubcategory: STORAGELOCATION_CONFIG.menuSubcategory,
      menuTitle: STORAGELOCATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor-company-code',
    pathMatch: 'full',
    component: VendorCompanyCode,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDORCOMPANYCODE_CONFIG.permission,
      showInMenu: VENDORCOMPANYCODE_CONFIG.showInMenu,
      menuCategory: VENDORCOMPANYCODE_CONFIG.menuCategory,
      menuSubcategory: VENDORCOMPANYCODE_CONFIG.menuSubcategory,
      menuTitle: VENDORCOMPANYCODE_CONFIG.localizationKey,
    },
  },
  {
    path: 'purchase-order-detail',
    pathMatch: 'full',
    component: PurchaseOrderDetail,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PURCHASEORDERDETAIL_CONFIG.permission,
      showInMenu: PURCHASEORDERDETAIL_CONFIG.showInMenu,
      menuCategory: PURCHASEORDERDETAIL_CONFIG.menuCategory,
      menuSubcategory: PURCHASEORDERDETAIL_CONFIG.menuSubcategory,
      menuTitle: PURCHASEORDERDETAIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'cost-receiver',
    pathMatch: 'full',
    component: CostReceiver,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: COSTRECEIVER_CONFIG.permission,
      showInMenu: COSTRECEIVER_CONFIG.showInMenu,
      menuCategory: COSTRECEIVER_CONFIG.menuCategory,
      menuSubcategory: COSTRECEIVER_CONFIG.menuSubcategory,
      menuTitle: COSTRECEIVER_CONFIG.localizationKey,
    },
  },
  {
    path: 'work-front',
    pathMatch: 'full',
    component: WorkFront,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WORKFRONT_CONFIG.permission,
      showInMenu: WORKFRONT_CONFIG.showInMenu,
      menuCategory: WORKFRONT_CONFIG.menuCategory,
      menuSubcategory: WORKFRONT_CONFIG.menuSubcategory,
      menuTitle: WORKFRONT_CONFIG.localizationKey,
    },
  },
  {
    path: 'work-front-type',
    pathMatch: 'full',
    component: WorkFrontType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WORKFRONTTYPE_CONFIG.permission,
      showInMenu: WORKFRONTTYPE_CONFIG.showInMenu,
      menuCategory: WORKFRONTTYPE_CONFIG.menuCategory,
      menuSubcategory: WORKFRONTTYPE_CONFIG.menuSubcategory,
      menuTitle: WORKFRONTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'shift',
    pathMatch: 'full',
    component: Shift,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SHIFT_CONFIG.permission,
      showInMenu: SHIFT_CONFIG.showInMenu,
      menuCategory: SHIFT_CONFIG.menuCategory,
      menuSubcategory: SHIFT_CONFIG.menuSubcategory,
      menuTitle: SHIFT_CONFIG.localizationKey,
    },
  },
  {
    path: 'shift-group',
    pathMatch: 'full',
    component: ShiftGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SHIFTGROUP_CONFIG.permission,
      showInMenu: SHIFTGROUP_CONFIG.showInMenu,
      menuCategory: SHIFTGROUP_CONFIG.menuCategory,
      menuSubcategory: SHIFTGROUP_CONFIG.menuSubcategory,
      menuTitle: SHIFTGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor-shift-working-day',
    pathMatch: 'full',
    component: VendorShiftWorkingDay,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDORSHIFTWORKINGDAY_CONFIG.permission,
      showInMenu: VENDORSHIFTWORKINGDAY_CONFIG.showInMenu,
      menuCategory: VENDORSHIFTWORKINGDAY_CONFIG.menuCategory,
      menuTitle: VENDORSHIFTWORKINGDAY_CONFIG.localizationKey,
    },
  },
  {
    path: 'supplier-bank',
    pathMatch: 'full',
    component: SupplierBank,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SUPPLIERBANK_CONFIG.permission,
      showInMenu: SUPPLIERBANK_CONFIG.showInMenu,
      menuCategory: SUPPLIERBANK_CONFIG.menuCategory,
      menuSubcategory: SUPPLIERBANK_CONFIG.menuSubcategory,
      menuTitle: SUPPLIERBANK_CONFIG.localizationKey,
    },
  },
  {
    path: 'shift-working-day',
    pathMatch: 'full',
    component: ShiftWorkingDay,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SHIFTWORKINGDAY_CONFIG.permission,
      showInMenu: SHIFTWORKINGDAY_CONFIG.showInMenu,
      menuCategory: SHIFTWORKINGDAY_CONFIG.menuCategory,
      menuSubcategory: SHIFTWORKINGDAY_CONFIG.menuSubcategory,
      menuTitle: SHIFTWORKINGDAY_CONFIG.localizationKey,
    },
  },
  {
    path: 'substitute-document-type',
    pathMatch: 'full',
    component: SubstituteDocumentType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SUBSTITUTEDOCUMENTTYPE_CONFIG.permission,
      showInMenu: SUBSTITUTEDOCUMENTTYPE_CONFIG.showInMenu,
      menuCategory: SUBSTITUTEDOCUMENTTYPE_CONFIG.menuCategory,
      menuSubcategory: SUBSTITUTEDOCUMENTTYPE_CONFIG.menuSubcategory,
      menuTitle: SUBSTITUTEDOCUMENTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'process',
    pathMatch: 'full',
    component: Process,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROCESS_CONFIG.permission,
      showInMenu: PROCESS_CONFIG.showInMenu,
      menuCategory: PROCESS_CONFIG.menuCategory,
      menuSubcategory: PROCESS_CONFIG.menuSubcategory,
      menuTitle: PROCESS_CONFIG.localizationKey,
    },
  },
  {
    path: 'quarry-type',
    pathMatch: 'full',
    component: QuarryType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: QUARRYTYPE_CONFIG.permission,
      showInMenu: QUARRYTYPE_CONFIG.showInMenu,
      menuCategory: QUARRYTYPE_CONFIG.menuCategory,
      menuSubcategory: QUARRYTYPE_CONFIG.menuSubcategory,
      menuTitle: QUARRYTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'road-distance',
    pathMatch: 'full',
    component: RoadDistance,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ROADDISTANCE_CONFIG.permission,
      showInMenu: ROADDISTANCE_CONFIG.showInMenu,
      menuCategory: ROADDISTANCE_CONFIG.menuCategory,
      menuSubcategory: ROADDISTANCE_CONFIG.menuSubcategory,
      menuTitle: ROADDISTANCE_CONFIG.localizationKey,
    },
  },
  {
    path: 'road-cargo-type',
    pathMatch: 'full',
    component: RoadCargoType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ROADCARGOTYPE_CONFIG.permission,
      showInMenu: ROADCARGOTYPE_CONFIG.showInMenu,
      menuCategory: ROADCARGOTYPE_CONFIG.menuCategory,
      menuSubcategory: ROADCARGOTYPE_CONFIG.menuSubcategory,
      menuTitle: ROADCARGOTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'document-type',
    pathMatch: 'full',
    component: DocumentType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DOCUMENTTYPE_CONFIG.permission,
      showInMenu: DOCUMENTTYPE_CONFIG.showInMenu,
      menuCategory: DOCUMENTTYPE_CONFIG.menuCategory,
      menuSubcategory: DOCUMENTTYPE_CONFIG.menuSubcategory,
      menuTitle: DOCUMENTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'activity',
    pathMatch: 'full',
    component: Activity,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACTIVITY_CONFIG.permission,
      showInMenu: ACTIVITY_CONFIG.showInMenu,
      menuCategory: ACTIVITY_CONFIG.menuCategory,
      menuSubcategory: ACTIVITY_CONFIG.menuSubcategory,
      menuTitle: ACTIVITY_CONFIG.localizationKey,
    },
  },
  {
    path: 'stage',
    pathMatch: 'full',
    component: Stage,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STAGE_CONFIG.permission,
      showInMenu: STAGE_CONFIG.showInMenu,
      menuCategory: STAGE_CONFIG.menuCategory,
      menuSubcategory: STAGE_CONFIG.menuSubcategory,
      menuTitle: STAGE_CONFIG.localizationKey,
    },
  },
  {
    path: 'activity-moment',
    pathMatch: 'full',
    component: ActivityMoment,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACTIVITYMOMENT_CONFIG.permission,
      showInMenu: ACTIVITYMOMENT_CONFIG.showInMenu,
      menuCategory: ACTIVITYMOMENT_CONFIG.menuCategory,
      menuSubcategory: ACTIVITYMOMENT_CONFIG.menuSubcategory,
      menuTitle: ACTIVITYMOMENT_CONFIG.localizationKey,
    },
  },
  {
    path: 'activity-place',
    pathMatch: 'full',
    component: ActivityPlace,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACTIVITYPLACE_CONFIG.permission,
      showInMenu: ACTIVITYPLACE_CONFIG.showInMenu,
      menuCategory: ACTIVITYPLACE_CONFIG.menuCategory,
      menuSubcategory: ACTIVITYPLACE_CONFIG.menuSubcategory,
      menuTitle: ACTIVITYPLACE_CONFIG.localizationKey,
    },
  },
  {
    path: 'activity-tool',
    pathMatch: 'full',
    component: ActivityTool,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACTIVITYTOOL_CONFIG.permission,
      showInMenu: ACTIVITYTOOL_CONFIG.showInMenu,
      menuCategory: ACTIVITYTOOL_CONFIG.menuCategory,
      menuSubcategory: ACTIVITYTOOL_CONFIG.menuSubcategory,
      menuTitle: ACTIVITYTOOL_CONFIG.localizationKey,
    },
  },
  {
    path: 'activity-reason',
    pathMatch: 'full',
    component: ActivityReason,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACTIVITYREASON_CONFIG.permission,
      showInMenu: ACTIVITYREASON_CONFIG.showInMenu,
      menuCategory: ACTIVITYREASON_CONFIG.menuCategory,
      menuSubcategory: ACTIVITYREASON_CONFIG.menuSubcategory,
      menuTitle: ACTIVITYREASON_CONFIG.localizationKey,
    },
  },
  {
    path: 'activity-per-stage',
    pathMatch: 'full',
    component: ActivityPerStage,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACTIVITYPERSTAGE_CONFIG.permission,
      showInMenu: ACTIVITYPERSTAGE_CONFIG.showInMenu,
      menuCategory: ACTIVITYPERSTAGE_CONFIG.menuCategory,
      menuSubcategory: ACTIVITYPERSTAGE_CONFIG.menuSubcategory,
      menuTitle: ACTIVITYPERSTAGE_CONFIG.localizationKey,
    },
  },
  {
    path: 'level',
    pathMatch: 'full',
    component: Level,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LEVEL_CONFIG.permission,
      showInMenu: LEVEL_CONFIG.showInMenu,
      menuCategory: LEVEL_CONFIG.menuCategory,
      menuSubcategory: LEVEL_CONFIG.menuSubcategory,
      menuTitle: LEVEL_CONFIG.localizationKey,
    },
  },
  {
    path: 'level-per-activity',
    pathMatch: 'full',
    component: LevelPerActivity,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LEVELPERACTIVITY_CONFIG.permission,
      showInMenu: LEVELPERACTIVITY_CONFIG.showInMenu,
      menuCategory: LEVELPERACTIVITY_CONFIG.menuCategory,
      menuSubcategory: LEVELPERACTIVITY_CONFIG.menuSubcategory,
      menuTitle: LEVELPERACTIVITY_CONFIG.localizationKey,
    },
  },
  {
    path: 'level-per-process',
    pathMatch: 'full',
    component: LevelPerProcess,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LEVELPERPROCESS_CONFIG.permission,
      showInMenu: LEVELPERPROCESS_CONFIG.showInMenu,
      menuCategory: LEVELPERPROCESS_CONFIG.menuCategory,
      menuSubcategory: LEVELPERPROCESS_CONFIG.menuSubcategory,
      menuTitle: LEVELPERPROCESS_CONFIG.localizationKey,
    },
  },
  {
    path: 'event-category',
    pathMatch: 'full',
    component: EventCategory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: EVENTCATEGORY_CONFIG.permission,
      showInMenu: EVENTCATEGORY_CONFIG.showInMenu,
      menuCategory: EVENTCATEGORY_CONFIG.menuCategory,
      menuSubcategory: EVENTCATEGORY_CONFIG.menuSubcategory,
      menuTitle: EVENTCATEGORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'event',
    pathMatch: 'full',
    component: Event,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: EVENT_CONFIG.permission,
      showInMenu: EVENT_CONFIG.showInMenu,
      menuCategory: EVENT_CONFIG.menuCategory,
      menuSubcategory: EVENT_CONFIG.menuSubcategory,
      menuTitle: EVENT_CONFIG.localizationKey,
    },
  },
  {
    path: 'document-type-per-activity',
    pathMatch: 'full',
    component: DocumentTypePerActivity,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DOCUMENTTYPEPERACTIVITY_CONFIG.permission,
      showInMenu: DOCUMENTTYPEPERACTIVITY_CONFIG.showInMenu,
      menuCategory: DOCUMENTTYPEPERACTIVITY_CONFIG.menuCategory,
      menuSubcategory: DOCUMENTTYPEPERACTIVITY_CONFIG.menuSubcategory,
      menuTitle: DOCUMENTTYPEPERACTIVITY_CONFIG.localizationKey,
    },
  },
  {
    path: 'activity-process-parametrization',
    pathMatch: 'full',
    component: ActivityProcessParametrization,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACTIVITYPROCESSPARAMETRIZATION_CONFIG.permission,
      showInMenu: ACTIVITYPROCESSPARAMETRIZATION_CONFIG.showInMenu,
      menuCategory: ACTIVITYPROCESSPARAMETRIZATION_CONFIG.menuCategory,
      menuSubcategory: ACTIVITYPROCESSPARAMETRIZATION_CONFIG.menuSubcategory,
      menuTitle: ACTIVITYPROCESSPARAMETRIZATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'consumable-accepted-per-activity',
    pathMatch: 'full',
    component: ConsumableAcceptedPerActivity,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONSUMABLEACCEPTEDPERACTIVITY_CONFIG.permission,
      showInMenu: CONSUMABLEACCEPTEDPERACTIVITY_CONFIG.showInMenu,
      menuCategory: CONSUMABLEACCEPTEDPERACTIVITY_CONFIG.menuCategory,
      menuSubcategory: CONSUMABLEACCEPTEDPERACTIVITY_CONFIG.menuSubcategory,
      menuTitle: CONSUMABLEACCEPTEDPERACTIVITY_CONFIG.localizationKey,
    },
  },
  {
    path: 'scope-type',
    pathMatch: 'full',
    component: ScopeType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SCOPETYPE_CONFIG.permission,
      showInMenu: SCOPETYPE_CONFIG.showInMenu,
      menuCategory: SCOPETYPE_CONFIG.menuCategory,
      menuSubcategory: SCOPETYPE_CONFIG.menuSubcategory,
      menuTitle: SCOPETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'road-activity-parameter',
    pathMatch: 'full',
    component: RoadActivityParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ROADACTIVITYPARAMETER_CONFIG.permission,
      showInMenu: ROADACTIVITYPARAMETER_CONFIG.showInMenu,
      menuCategory: ROADACTIVITYPARAMETER_CONFIG.menuCategory,
      menuSubcategory: ROADACTIVITYPARAMETER_CONFIG.menuSubcategory,
      menuTitle: ROADACTIVITYPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'process-per-profile',
    pathMatch: 'full',
    component: ProcessPerProfile,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROCESSPERPROFILE_CONFIG.permission,
      showInMenu: PROCESSPERPROFILE_CONFIG.showInMenu,
      menuCategory: PROCESSPERPROFILE_CONFIG.menuCategory,
      menuSubcategory: PROCESSPERPROFILE_CONFIG.menuSubcategory,
      menuTitle: PROCESSPERPROFILE_CONFIG.localizationKey,
    },
  },
  {
    path: 'patrimony-activity-parameter',
    pathMatch: 'full',
    component: PatrimonyActivityParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PATRIMONYACTIVITYPARAMETER_CONFIG.permission,
      showInMenu: PATRIMONYACTIVITYPARAMETER_CONFIG.showInMenu,
      menuCategory: PATRIMONYACTIVITYPARAMETER_CONFIG.menuCategory,
      menuSubcategory: PATRIMONYACTIVITYPARAMETER_CONFIG.menuSubcategory,
      menuTitle: PATRIMONYACTIVITYPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'silviculture-activity-parameter',
    pathMatch: 'full',
    component: SilvicultureActivityParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SILVICULTUREACTIVITYPARAMETER_CONFIG.permission,
      showInMenu: SILVICULTUREACTIVITYPARAMETER_CONFIG.showInMenu,
      menuCategory: SILVICULTUREACTIVITYPARAMETER_CONFIG.menuCategory,
      menuSubcategory: SILVICULTUREACTIVITYPARAMETER_CONFIG.menuSubcategory,
      menuTitle: SILVICULTUREACTIVITYPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'stage-per-process',
    pathMatch: 'full',
    component: StagePerProcess,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STAGEPERPROCESS_CONFIG.permission,
      showInMenu: STAGEPERPROCESS_CONFIG.showInMenu,
      menuCategory: STAGEPERPROCESS_CONFIG.menuCategory,
      menuSubcategory: STAGEPERPROCESS_CONFIG.menuSubcategory,
      menuTitle: STAGEPERPROCESS_CONFIG.localizationKey,
    },
  },
  {
    path: 'location-type-per-activity',
    pathMatch: 'full',
    component: LocationTypePerActivity,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOCATIONTYPEPERACTIVITY_CONFIG.permission,
      showInMenu: LOCATIONTYPEPERACTIVITY_CONFIG.showInMenu,
      menuCategory: LOCATIONTYPEPERACTIVITY_CONFIG.menuCategory,
      menuSubcategory: LOCATIONTYPEPERACTIVITY_CONFIG.menuSubcategory,
      menuTitle: LOCATIONTYPEPERACTIVITY_CONFIG.localizationKey,
    },
  },
  {
    path: 'harvest-activity-parameter',
    pathMatch: 'full',
    component: HarvestActivityParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HARVESTACTIVITYPARAMETER_CONFIG.permission,
      showInMenu: HARVESTACTIVITYPARAMETER_CONFIG.showInMenu,
      menuCategory: HARVESTACTIVITYPARAMETER_CONFIG.menuCategory,
      menuSubcategory: HARVESTACTIVITYPARAMETER_CONFIG.menuSubcategory,
      menuTitle: HARVESTACTIVITYPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'nursery-activity-parameter',
    pathMatch: 'full',
    component: NurseryActivityParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: NURSERYACTIVITYPARAMETER_CONFIG.permission,
      showInMenu: NURSERYACTIVITYPARAMETER_CONFIG.showInMenu,
      menuCategory: NURSERYACTIVITYPARAMETER_CONFIG.menuCategory,
      menuSubcategory: NURSERYACTIVITYPARAMETER_CONFIG.menuSubcategory,
      menuTitle: NURSERYACTIVITYPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'activity-per-nursery',
    pathMatch: 'full',
    component: ActivityPerNursery,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACTIVITYPERNURSERY_CONFIG.permission,
      showInMenu: ACTIVITYPERNURSERY_CONFIG.showInMenu,
      menuCategory: ACTIVITYPERNURSERY_CONFIG.menuCategory,
      menuSubcategory: ACTIVITYPERNURSERY_CONFIG.menuSubcategory,
      menuTitle: ACTIVITYPERNURSERY_CONFIG.localizationKey,
    },
  },
  {
    path: 'nursery-activity-quality-control',
    pathMatch: 'full',
    component: NurseryActivityQualityControl,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: NURSERYACTIVITYQUALITYCONTROL_CONFIG.permission,
      showInMenu: NURSERYACTIVITYQUALITYCONTROL_CONFIG.showInMenu,
      menuCategory: NURSERYACTIVITYQUALITYCONTROL_CONFIG.menuCategory,
      menuSubcategory: NURSERYACTIVITYQUALITYCONTROL_CONFIG.menuSubcategory,
      menuTitle: NURSERYACTIVITYQUALITYCONTROL_CONFIG.localizationKey,
    },
  },
  {
    path: 'logistics-activity-parameter',
    pathMatch: 'full',
    component: LogisticsActivityParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOGISTICSACTIVITYPARAMETER_CONFIG.permission,
      showInMenu: LOGISTICSACTIVITYPARAMETER_CONFIG.showInMenu,
      menuCategory: LOGISTICSACTIVITYPARAMETER_CONFIG.menuCategory,
      menuSubcategory: LOGISTICSACTIVITYPARAMETER_CONFIG.menuSubcategory,
      menuTitle: LOGISTICSACTIVITYPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'person-per-work-front',
    pathMatch: 'full',
    component: PersonPerWorkFront,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PERSONPERWORKFRONT_CONFIG.permission,
      showInMenu: PERSONPERWORKFRONT_CONFIG.showInMenu,
      menuCategory: PERSONPERWORKFRONT_CONFIG.menuCategory,
      menuSubcategory: PERSONPERWORKFRONT_CONFIG.menuSubcategory,
      menuTitle: PERSONPERWORKFRONT_CONFIG.localizationKey,
    },
  },
  {
    path: 'machine-per-work-front',
    pathMatch: 'full',
    component: MachinePerWorkFront,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MACHINEPERWORKFRONT_CONFIG.permission,
      showInMenu: MACHINEPERWORKFRONT_CONFIG.showInMenu,
      menuCategory: MACHINEPERWORKFRONT_CONFIG.menuCategory,
      menuSubcategory: MACHINEPERWORKFRONT_CONFIG.menuSubcategory,
      menuTitle: MACHINEPERWORKFRONT_CONFIG.localizationKey,
    },
  },
  {
    path: 'route-corridor',
    pathMatch: 'full',
    component: RouteCorridor,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ROUTECORRIDOR_CONFIG.permission,
      showInMenu: ROUTECORRIDOR_CONFIG.showInMenu,
      menuCategory: ROUTECORRIDOR_CONFIG.menuCategory,
      menuSubcategory: ROUTECORRIDOR_CONFIG.menuSubcategory,
      menuTitle: ROUTECORRIDOR_CONFIG.localizationKey,
    },
  },
  {
    path: 'closing-stage-status-parameters',
    pathMatch: 'full',
    component: ClosingStageStatusParameters,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CLOSINGSTAGESTATUSPARAMETERS_CONFIG.permission,
      showInMenu: CLOSINGSTAGESTATUSPARAMETERS_CONFIG.showInMenu,
      menuCategory: CLOSINGSTAGESTATUSPARAMETERS_CONFIG.menuCategory,
      menuSubcategory: CLOSINGSTAGESTATUSPARAMETERS_CONFIG.menuSubcategory,
      menuTitle: CLOSINGSTAGESTATUSPARAMETERS_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-type-usage',
    pathMatch: 'full',
    component: ContractTypeUsage,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPEUSAGE_CONFIG.permission,
      showInMenu: CONTRACTTYPEUSAGE_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPEUSAGE_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPEUSAGE_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPEUSAGE_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-variable',
    pathMatch: 'full',
    component: ContractVariable,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTVARIABLE_CONFIG.permission,
      showInMenu: CONTRACTVARIABLE_CONFIG.showInMenu,
      menuCategory: CONTRACTVARIABLE_CONFIG.menuCategory,
      menuSubcategory: CONTRACTVARIABLE_CONFIG.menuSubcategory,
      menuTitle: CONTRACTVARIABLE_CONFIG.localizationKey,
    },
  },
  {
    path: 'fuel-consumption-type',
    pathMatch: 'full',
    component: FuelConsumptionType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FUELCONSUMPTIONTYPE_CONFIG.permission,
      showInMenu: FUELCONSUMPTIONTYPE_CONFIG.showInMenu,
      menuCategory: FUELCONSUMPTIONTYPE_CONFIG.menuCategory,
      menuSubcategory: FUELCONSUMPTIONTYPE_CONFIG.menuSubcategory,
      menuTitle: FUELCONSUMPTIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-type-asset',
    pathMatch: 'full',
    component: ContractTypeAsset,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPEASSET_CONFIG.permission,
      showInMenu: CONTRACTTYPEASSET_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPEASSET_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPEASSET_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPEASSET_CONFIG.localizationKey,
    },
  },
  {
    path: 'conditional-for-calculation',
    pathMatch: 'full',
    component: ConditionalForCalculation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONDITIONALFORCALCULATION_CONFIG.permission,
      showInMenu: CONDITIONALFORCALCULATION_CONFIG.showInMenu,
      menuCategory: CONDITIONALFORCALCULATION_CONFIG.menuCategory,
      menuSubcategory: CONDITIONALFORCALCULATION_CONFIG.menuSubcategory,
      menuTitle: CONDITIONALFORCALCULATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-type-group',
    pathMatch: 'full',
    component: ContractTypeGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPEGROUP_CONFIG.permission,
      showInMenu: CONTRACTTYPEGROUP_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPEGROUP_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPEGROUP_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPEGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'single-customs-declaration',
    pathMatch: 'full',
    component: SingleCustomsDeclaration,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SINGLECUSTOMSDECLARATION_CONFIG.permission,
      showInMenu: SINGLECUSTOMSDECLARATION_CONFIG.showInMenu,
      menuCategory: SINGLECUSTOMSDECLARATION_CONFIG.menuCategory,
      menuSubcategory: SINGLECUSTOMSDECLARATION_CONFIG.menuSubcategory,
      menuTitle: SINGLECUSTOMSDECLARATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'sale-order-parametrization',
    pathMatch: 'full',
    component: SaleOrderParametrization,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SALEORDERPARAMETRIZATION_CONFIG.permission,
      showInMenu: SALEORDERPARAMETRIZATION_CONFIG.showInMenu,
      menuCategory: SALEORDERPARAMETRIZATION_CONFIG.menuCategory,
      menuSubcategory: SALEORDERPARAMETRIZATION_CONFIG.menuSubcategory,
      menuTitle: SALEORDERPARAMETRIZATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'property-type-region-parameter',
    pathMatch: 'full',
    component: PropertyTypeRegionParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROPERTYTYPEREGIONPARAMETER_CONFIG.permission,
      showInMenu: PROPERTYTYPEREGIONPARAMETER_CONFIG.showInMenu,
      menuCategory: PROPERTYTYPEREGIONPARAMETER_CONFIG.menuCategory,
      menuSubcategory: PROPERTYTYPEREGIONPARAMETER_CONFIG.menuSubcategory,
      menuTitle: PROPERTYTYPEREGIONPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'exchange-type',
    pathMatch: 'full',
    component: ExchangeType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: EXCHANGETYPE_CONFIG.permission,
      showInMenu: EXCHANGETYPE_CONFIG.showInMenu,
      menuCategory: EXCHANGETYPE_CONFIG.menuCategory,
      menuSubcategory: EXCHANGETYPE_CONFIG.menuSubcategory,
      menuTitle: EXCHANGETYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'depletion-exchange-amount',
    pathMatch: 'full',
    component: DepletionExchangeAmount,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DEPLETIONEXCHANGEAMOUNT_CONFIG.permission,
      showInMenu: DEPLETIONEXCHANGEAMOUNT_CONFIG.showInMenu,
      menuCategory: DEPLETIONEXCHANGEAMOUNT_CONFIG.menuCategory,
      menuSubcategory: DEPLETIONEXCHANGEAMOUNT_CONFIG.menuSubcategory,
      menuTitle: DEPLETIONEXCHANGEAMOUNT_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor-contract-type',
    pathMatch: 'full',
    component: VendorContractType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDORCONTRACTTYPE_CONFIG.permission,
      showInMenu: VENDORCONTRACTTYPE_CONFIG.showInMenu,
      menuCategory: VENDORCONTRACTTYPE_CONFIG.menuCategory,
      menuSubcategory: VENDORCONTRACTTYPE_CONFIG.menuSubcategory,
      menuTitle: VENDORCONTRACTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'sale-order-parameter-value',
    pathMatch: 'full',
    component: SaleOrderParameterValue,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SALEORDERPARAMETERVALUE_CONFIG.permission,
      showInMenu: SALEORDERPARAMETERVALUE_CONFIG.showInMenu,
      menuCategory: SALEORDERPARAMETERVALUE_CONFIG.menuCategory,
      menuSubcategory: SALEORDERPARAMETERVALUE_CONFIG.menuSubcategory,
      menuTitle: SALEORDERPARAMETERVALUE_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor-type',
    pathMatch: 'full',
    component: VendorType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDORTYPE_CONFIG.permission,
      showInMenu: VENDORTYPE_CONFIG.showInMenu,
      menuCategory: VENDORTYPE_CONFIG.menuCategory,
      menuSubcategory: VENDORTYPE_CONFIG.menuSubcategory,
      menuTitle: VENDORTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'asset',
    pathMatch: 'full',
    component: Asset,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ASSET_CONFIG.permission,
      showInMenu: ASSET_CONFIG.showInMenu,
      menuCategory: ASSET_CONFIG.menuCategory,
      menuSubcategory: ASSET_CONFIG.menuSubcategory,
      menuTitle: ASSET_CONFIG.localizationKey,
    },
  },
  {
    path: 'internal-order-type',
    pathMatch: 'full',
    component: InternalOrderType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INTERNALORDERTYPE_CONFIG.permission,
      showInMenu: INTERNALORDERTYPE_CONFIG.showInMenu,
      menuCategory: INTERNALORDERTYPE_CONFIG.menuCategory,
      menuSubcategory: INTERNALORDERTYPE_CONFIG.menuSubcategory,
      menuTitle: INTERNALORDERTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'movement-type',
    pathMatch: 'full',
    component: MovementType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: MOVEMENTTYPE_CONFIG.permission,
      showInMenu: MOVEMENTTYPE_CONFIG.showInMenu,
      menuCategory: MOVEMENTTYPE_CONFIG.menuCategory,
      menuSubcategory: MOVEMENTTYPE_CONFIG.menuSubcategory,
      menuTitle: MOVEMENTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'service-master',
    pathMatch: 'full',
    component: ServiceMaster,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SERVICEMASTER_CONFIG.permission,
      showInMenu: SERVICEMASTER_CONFIG.showInMenu,
      menuCategory: SERVICEMASTER_CONFIG.menuCategory,
      menuSubcategory: SERVICEMASTER_CONFIG.menuSubcategory,
      menuTitle: SERVICEMASTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-material-type',
    pathMatch: 'full',
    component: SapMaterialType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPMATERIALTYPE_CONFIG.permission,
      showInMenu: SAPMATERIALTYPE_CONFIG.showInMenu,
      menuCategory: SAPMATERIALTYPE_CONFIG.menuCategory,
      menuSubcategory: SAPMATERIALTYPE_CONFIG.menuSubcategory,
      menuTitle: SAPMATERIALTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-material-group',
    pathMatch: 'full',
    component: SapMaterialGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPMATERIALGROUP_CONFIG.permission,
      showInMenu: SAPMATERIALGROUP_CONFIG.showInMenu,
      menuCategory: SAPMATERIALGROUP_CONFIG.menuCategory,
      menuSubcategory: SAPMATERIALGROUP_CONFIG.menuSubcategory,
      menuTitle: SAPMATERIALGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-material',
    pathMatch: 'full',
    component: SapMaterial,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPMATERIAL_CONFIG.permission,
      showInMenu: SAPMATERIAL_CONFIG.showInMenu,
      menuCategory: SAPMATERIAL_CONFIG.menuCategory,
      menuSubcategory: SAPMATERIAL_CONFIG.menuSubcategory,
      menuTitle: SAPMATERIAL_CONFIG.localizationKey,
    },
  },  {
    path: 'contract-type-activity',
    pathMatch: 'full',
    component: ContractTypeActivity,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPEACTIVITY_CONFIG.permission,
      showInMenu: CONTRACTTYPEACTIVITY_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPEACTIVITY_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPEACTIVITY_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPEACTIVITY_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-type-forecast',
    pathMatch: 'full',
    component: ContractTypeForecast,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPEFORECAST_CONFIG.permission,
      showInMenu: CONTRACTTYPEFORECAST_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPEFORECAST_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPEFORECAST_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPEFORECAST_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-type-mgs-parameter',
    pathMatch: 'full',
    component: ContractTypeMgsParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPEMGSPARAMETER_CONFIG.permission,
      showInMenu: CONTRACTTYPEMGSPARAMETER_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPEMGSPARAMETER_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPEMGSPARAMETER_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPEMGSPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-type-per-property-type',
    pathMatch: 'full',
    component: ContractTypePerPropertyType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPEPERPROPERTYTYPE_CONFIG.permission,
      showInMenu: CONTRACTTYPEPERPROPERTYTYPE_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPEPERPROPERTYTYPE_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPEPERPROPERTYTYPE_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPEPERPROPERTYTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-type-sap-parameter',
    pathMatch: 'full',
    component: ContractTypeSapParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPESAPPARAMETER_CONFIG.permission,
      showInMenu: CONTRACTTYPESAPPARAMETER_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPESAPPARAMETER_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPESAPPARAMETER_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPESAPPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-type-tax',
    pathMatch: 'full',
    component: ContractTypeTax,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTTYPETAX_CONFIG.permission,
      showInMenu: CONTRACTTYPETAX_CONFIG.showInMenu,
      menuCategory: CONTRACTTYPETAX_CONFIG.menuCategory,
      menuSubcategory: CONTRACTTYPETAX_CONFIG.menuSubcategory,
      menuTitle: CONTRACTTYPETAX_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-fico-parameter',
    pathMatch: 'full',
    component: SapFicoParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPFICOPARAMETER_CONFIG.permission,
      showInMenu: SAPFICOPARAMETER_CONFIG.showInMenu,
      menuCategory: SAPFICOPARAMETER_CONFIG.menuCategory,
      menuSubcategory: SAPFICOPARAMETER_CONFIG.menuSubcategory,
      menuTitle: SAPFICOPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-fi-parameter',
    pathMatch: 'full',
    component: SapFiParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPFIPARAMETER_CONFIG.permission,
      showInMenu: SAPFIPARAMETER_CONFIG.showInMenu,
      menuCategory: SAPFIPARAMETER_CONFIG.menuCategory,
      menuSubcategory: SAPFIPARAMETER_CONFIG.menuSubcategory,
      menuTitle: SAPFIPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-service-entry-sheet-parameter',
    pathMatch: 'full',
    component: SapServiceEntrySheetParameter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPSERVICEENTRYSHEETPARAMETER_CONFIG.permission,
      showInMenu: SAPSERVICEENTRYSHEETPARAMETER_CONFIG.showInMenu,
      menuCategory: SAPSERVICEENTRYSHEETPARAMETER_CONFIG.menuCategory,
      menuSubcategory: SAPSERVICEENTRYSHEETPARAMETER_CONFIG.menuSubcategory,
      menuTitle: SAPSERVICEENTRYSHEETPARAMETER_CONFIG.localizationKey,
    },
  },
  {
    path: 'single-customs-declaration-material',
    pathMatch: 'full',
    component: SingleCustomsDeclarationMaterial,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SINGLECUSTOMSDECLARATIONMATERIAL_CONFIG.permission,
      showInMenu: SINGLECUSTOMSDECLARATIONMATERIAL_CONFIG.showInMenu,
      menuCategory: SINGLECUSTOMSDECLARATIONMATERIAL_CONFIG.menuCategory,
      menuSubcategory: SINGLECUSTOMSDECLARATIONMATERIAL_CONFIG.menuSubcategory,
      menuTitle: SINGLECUSTOMSDECLARATIONMATERIAL_CONFIG.localizationKey,
    },
  },
  {
    path: 'vehicle-TYPE-tons',
    pathMatch: 'full',
    component: VehicleTypeTons,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VEHICLETYPETONS_CONFIG.permission,
      showInMenu: VEHICLETYPETONS_CONFIG.showInMenu,
      menuCategory: VEHICLETYPETONS_CONFIG.menuCategory,
      menuSubcategory: VEHICLETYPETONS_CONFIG.menuSubcategory,
      menuTitle: VEHICLETYPETONS_CONFIG.localizationKey,
    },
  },
  {
    path: 'logistics-main-truck-count',
    pathMatch: 'full',
    component: LogisticsMainTruckCount,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOGISTICSMAINTRUCKCOUNT_CONFIG.permission,
      showInMenu: LOGISTICSMAINTRUCKCOUNT_CONFIG.showInMenu,
      menuCategory: LOGISTICSMAINTRUCKCOUNT_CONFIG.menuCategory,
      menuSubcategory: LOGISTICSMAINTRUCKCOUNT_CONFIG.menuSubcategory,
      menuTitle: LOGISTICSMAINTRUCKCOUNT_CONFIG.localizationKey,
    },
  },
  {
    path: 'logistics-truck-count',
    pathMatch: 'full',
    component: LogisticsTruckCount,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOGISTICSTRUCKCOUNT_CONFIG.permission,
      showInMenu: LOGISTICSTRUCKCOUNT_CONFIG.showInMenu,
      menuCategory: LOGISTICSTRUCKCOUNT_CONFIG.menuCategory,
      menuSubcategory: LOGISTICSTRUCKCOUNT_CONFIG.menuSubcategory,
      menuTitle: LOGISTICSTRUCKCOUNT_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-account-company-code',
    pathMatch: 'full',
    component: SapAccountCompanyCode,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPACCOUNTCOMPANYCODE_CONFIG.permission,
      showInMenu: SAPACCOUNTCOMPANYCODE_CONFIG.showInMenu,
      menuCategory: SAPACCOUNTCOMPANYCODE_CONFIG.menuCategory,
      menuSubcategory: SAPACCOUNTCOMPANYCODE_CONFIG.menuSubcategory,
      menuTitle: SAPACCOUNTCOMPANYCODE_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-relation-sap-account-old-account',
    pathMatch: 'full',
    component: SapRelationSapAccountOldAccount,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPRELATIONSAPACCOUNTOLDACCOUNT_CONFIG.permission,
      showInMenu: SAPRELATIONSAPACCOUNTOLDACCOUNT_CONFIG.showInMenu,
      menuCategory: SAPRELATIONSAPACCOUNTOLDACCOUNT_CONFIG.menuCategory,
      menuSubcategory: SAPRELATIONSAPACCOUNTOLDACCOUNT_CONFIG.menuSubcategory,
      menuTitle: SAPRELATIONSAPACCOUNTOLDACCOUNT_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-old-profit-center',
    pathMatch: 'full',
    component: SapOldProfitCenter,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPOLDPROFITCENTER_CONFIG.permission,
      showInMenu: SAPOLDPROFITCENTER_CONFIG.showInMenu,
      menuCategory: SAPOLDPROFITCENTER_CONFIG.menuCategory,
      menuSubcategory: SAPOLDPROFITCENTER_CONFIG.menuSubcategory,
      menuTitle: SAPOLDPROFITCENTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'account-detail',
    pathMatch: 'full',
    component: AccountDetail,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ACCOUNTDETAIL_CONFIG.permission,
      showInMenu: ACCOUNTDETAIL_CONFIG.showInMenu,
      menuCategory: ACCOUNTDETAIL_CONFIG.menuCategory,
      menuSubcategory: ACCOUNTDETAIL_CONFIG.menuSubcategory,
      menuTitle: ACCOUNTDETAIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-account-group',
    pathMatch: 'full',
    component: SapAccountGroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPACCOUNTGROUP_CONFIG.permission,
      showInMenu: SAPACCOUNTGROUP_CONFIG.showInMenu,
      menuCategory: SAPACCOUNTGROUP_CONFIG.menuCategory,
      menuSubcategory: SAPACCOUNTGROUP_CONFIG.menuSubcategory,
      menuTitle: SAPACCOUNTGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-account-subgroup',
    pathMatch: 'full',
    component: SapAccountSubgroup,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPACCOUNTSUBGROUP_CONFIG.permission,
      showInMenu: SAPACCOUNTSUBGROUP_CONFIG.showInMenu,
      menuCategory: SAPACCOUNTSUBGROUP_CONFIG.menuCategory,
      menuSubcategory: SAPACCOUNTSUBGROUP_CONFIG.menuSubcategory,
      menuTitle: SAPACCOUNTSUBGROUP_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-amount-type',
    pathMatch: 'full',
    component: SapAmountType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPAMOUNTTYPE_CONFIG.permission,
      showInMenu: SAPAMOUNTTYPE_CONFIG.showInMenu,
      menuCategory: SAPAMOUNTTYPE_CONFIG.menuCategory,
      menuSubcategory: SAPAMOUNTTYPE_CONFIG.menuSubcategory,
      menuTitle: SAPAMOUNTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-document-type',
    pathMatch: 'full',
    component: SapDocumentType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPDOCUMENTTYPE_CONFIG.permission,
      showInMenu: SAPDOCUMENTTYPE_CONFIG.showInMenu,
      menuCategory: SAPDOCUMENTTYPE_CONFIG.menuCategory,
      menuSubcategory: SAPDOCUMENTTYPE_CONFIG.menuSubcategory,
      menuTitle: SAPDOCUMENTTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'old-account',
    pathMatch: 'full',
    component: OldAccount,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: OLDACCOUNT_CONFIG.permission,
      showInMenu: OLDACCOUNT_CONFIG.showInMenu,
      menuCategory: OLDACCOUNT_CONFIG.menuCategory,
      menuSubcategory: OLDACCOUNT_CONFIG.menuSubcategory,
      menuTitle: OLDACCOUNT_CONFIG.localizationKey,
    },
  },
  {
    path: 'sap-posting-key',
    pathMatch: 'full',
    component: SapPostingKey,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SAPPOSTINGKEY_CONFIG.permission,
      showInMenu: SAPPOSTINGKEY_CONFIG.showInMenu,
      menuCategory: SAPPOSTINGKEY_CONFIG.menuCategory,
      menuSubcategory: SAPPOSTINGKEY_CONFIG.menuSubcategory,
      menuTitle: SAPPOSTINGKEY_CONFIG.localizationKey,
    },
  },
  {
    path: 'tax',
    pathMatch: 'full',
    component: Tax,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TAX_CONFIG.permission,
      showInMenu: TAX_CONFIG.showInMenu,
      menuCategory: TAX_CONFIG.menuCategory,
      menuSubcategory: TAX_CONFIG.menuSubcategory,
      menuTitle: TAX_CONFIG.localizationKey,
    },
  },
  {
    path: 'property-nursery-vendor',
    pathMatch: 'full',
    component: PropertyNurseryVendor,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROPERTYNURSERYVENDOR_CONFIG.permission,
      showInMenu: PROPERTYNURSERYVENDOR_CONFIG.showInMenu,
      menuCategory: PROPERTYNURSERYVENDOR_CONFIG.menuCategory,
      menuSubcategory: PROPERTYNURSERYVENDOR_CONFIG.menuSubcategory,
      menuTitle: PROPERTYNURSERYVENDOR_CONFIG.localizationKey,
    },
  },
  {
    path: 'sale-method',
    pathMatch: 'full',
    component: SaleMethod,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SALEMETHOD_CONFIG.permission,
      showInMenu: SALEMETHOD_CONFIG.showInMenu,
      menuCategory: SALEMETHOD_CONFIG.menuCategory,
      menuSubcategory: SALEMETHOD_CONFIG.menuSubcategory,
      menuTitle: SALEMETHOD_CONFIG.localizationKey,
    },
  },
  {
    path: 'via-sap-transport',
    pathMatch: 'full',
    component: ViaSapTransport,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VIASAPTRANSPORT_CONFIG.permission,
      showInMenu: VIASAPTRANSPORT_CONFIG.showInMenu,
      menuCategory: VIASAPTRANSPORT_CONFIG.menuCategory,
      menuSubcategory: VIASAPTRANSPORT_CONFIG.menuSubcategory,
      menuTitle: VIASAPTRANSPORT_CONFIG.localizationKey,
    },
  },
  {
    path: 'sale-clause',
    pathMatch: 'full',
    component: SaleClause,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: SALECLAUSE_CONFIG.permission,
      showInMenu: SALECLAUSE_CONFIG.showInMenu,
      menuCategory: SALECLAUSE_CONFIG.menuCategory,
      menuSubcategory: SALECLAUSE_CONFIG.menuSubcategory,
      menuTitle: SALECLAUSE_CONFIG.localizationKey,
    },
  },
  {
    path: 'transfer-type',
    pathMatch: 'full',
    component: TransferType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TRANSFERTYPE_CONFIG.permission,
      showInMenu: TRANSFERTYPE_CONFIG.showInMenu,
      menuCategory: TRANSFERTYPE_CONFIG.menuCategory,
      menuSubcategory: TRANSFERTYPE_CONFIG.menuSubcategory,
      menuTitle: TRANSFERTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'via-sicfe-transport',
    pathMatch: 'full',
    component: ViaSicfeTransport,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VIASICFETRANSPORT_CONFIG.permission,
      showInMenu: VIASICFETRANSPORT_CONFIG.showInMenu,
      menuCategory: VIASICFETRANSPORT_CONFIG.menuCategory,
      menuSubcategory: VIASICFETRANSPORT_CONFIG.menuSubcategory,
      menuTitle: VIASICFETRANSPORT_CONFIG.localizationKey,
    },
  },
  {
    path: 'vendor-constraints-per-region',
    pathMatch: 'full',
    component: VendorConstraintsPerRegion,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: VENDORCONSTRAINTSPERREGION_CONFIG.permission,
      showInMenu: VENDORCONSTRAINTSPERREGION_CONFIG.showInMenu,
      menuCategory: VENDORCONSTRAINTSPERREGION_CONFIG.menuCategory,
      menuSubcategory: VENDORCONSTRAINTSPERREGION_CONFIG.menuSubcategory,
      menuTitle: VENDORCONSTRAINTSPERREGION_CONFIG.localizationKey,
    },
  },

];

export const CONTROLLING_ROUTES_WITH_PERMISSIONS = CONTROLLING_ROUTES;
